import Home from "./components/pages/Home";
import Logout from "./components/pages/Auth/Logout";
import MyLinks from "./components/pages/MemoLink/MyLinks";
import NotFound from "./components/pages/NotFound";
import MySubdomains from "./components/pages/Subdomains/List"
import ShowMl from "./components/pages/MemoLink/Show.vue"

export const routes = [
    {
        name: 'home',
        path: '/',

        component: Home,
        meta: {
            name: 'Create Memo Link',
            icon: 'fa-solid fa-link',
            visible: true,
        }
    },
    {
        name: 'memo-link.list',
        path: '/list',
        component: MyLinks,
        meta: {
            name: 'My Memo links',
            icon: 'fa-solid fa-link',
            visible: true,
        }
    },
    {
        name: 'subdomains.list',
        path: '/subdomain',
        component: MySubdomains,
        meta: {
            name: 'My Subdomain',
            icon: 'fa-regular fa-copyright',
            visible: true,
        }
    },
    {
        name: 'auth',
        path: '/auth',
        children: [
            {
                name: 'logout',
                path: 'logout',
                component: Logout,
                props: {allDevices: false}
            }
        ]
    },
    {
        name: 'memo-link.show',
        path: '/:memoLink(.*)*',
        component: ShowMl
    },

    // Should be the latest!
    {
        name: 'NotFound',
        path: '/:pathMatch(.*)*',
        component: NotFound
    },
];
